import BaseCtrl from 'edge/platform/base/BaseCtrl';

function updatePropertyIncidents(incidents, locations) {
    var newIncidentList = [];
    incidents.value.forEach(function (incident) {
        if (locations.some(function (location) {
            return location.number === incident.location;
        })) {
            newIncidentList.push(incident);
        }
    });
    locations.forEach(function (location) {
        if (!incidents.value.some(function (incident) {
            return location.number === incident.location;
        })) {
            newIncidentList.push({
                location: location.number
            });
        }
    });
    incidents.value = newIncidentList;
}

var fn = function fn($scope, claimViewModel) {
    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.claimVm = claimViewModel();
        $scope.propertyIncidentsVm = $scope.claimVm.lobs.commercialProperty.fixedPropertyIncidents;
        $scope.cpPolicyExtension = $scope.claimVm.policy.lobs.commercialProperty.value;

        updatePropertyIncidents($scope.propertyIncidentsVm, $scope.cpPolicyExtension.locations);
    };

    ctrl.next = function (nextFn) {
        nextFn($scope.claimVm);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'claimViewModel'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/cp/controllers/CPPropertyDetailsCtrl.js
// module id = 1534
// module chunks = 0